import { render, staticRenderFns } from "./EventTagDialog.vue?vue&type=template&id=5f290639&scoped=true"
import script from "./EventTagDialog.vue?vue&type=script&lang=js"
export * from "./EventTagDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f290639",
  null
  
)

export default component.exports